import styled from 'styled-components'
import {styled as muiStyled} from '@mui/material/styles'
import {MenuList, MenuItem} from '@mui/material'

export const MenuListStyled = muiStyled(MenuList)`
	padding-top: 0;
	padding-bottom: 0;
`

export const MenuItemStyled = muiStyled(MenuItem)(({theme}) => ({
  paddingTop: 10,
  paddingBottom: 10,
  color: theme.palette.primary.dark,
  fill: 'currentColor',
  '&:hover': {
    background: theme.palette.primary.main,
  },
}))

export const Text = styled.span`
  ${({IconBefore}) =>
    IconBefore && {
      marginLeft: '20px',
    }}
  ${({IconAfter}) =>
    IconAfter && {
      marginRight: '20px',
    }}
`

export const ButtonWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
